// extracted by mini-css-extract-plugin
export default {"container":"PageManagementScreen_container__Iysn1","content":"PageManagementScreen_content__WIH6o"};